import { RoomStateReportRequestModel } from '../api/models/ArrivalReportRequestModel';
import { RoomStateReportFormModel } from '../models';

export const dataFormToRequest = (data: RoomStateReportFormModel): RoomStateReportRequestModel => ({
  date: data.date,
  room_type_ids: data.room_type_ids,
  hk_states: (data.room_state || [])?.map(item => item),
  occupancies: (data.occupancies_type || [])?.map(item => item),
  file_type: data.file_type,
});
